export { default, placeholderPlugin } from './Placeholder';